// -------------------------------
// PAYSCALE INTERFACES
// -------------------------------
export interface PendingPayscale {
    RoleId?: string;
    SalaryRangeMin?: string;
    SalaryRangeMax?: string;
    ExperienceLevel?: string;
}

export interface PendingDeletePayscale {
    awaitingName?: boolean;
}
export const startCreatePayscaleFlow = (
    setPending: (data: PendingPayscale | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void
) => {
    setPending({});
    pushAIChat("Which role is this payscale for?");
    speak("Which role is this payscale for?");
    window.dispatchEvent(
        new CustomEvent("ai-suggest-options", {
            detail: { type: "payscale-role" },
        })
    )
};
export const processPendingPayscale = (
    text: string,
    pending: PendingPayscale,
    setPending: (data: PendingPayscale | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void,
    experienceSuggestions?: string[]
) => {

    // STEP 1 — Role
    if (!pending.RoleId) {
        setPending({ ...pending, RoleId: text });
        return;
    }

    // STEP 2 — Salary Min
    if (!pending.SalaryRangeMin) {
        setPending({ ...pending, SalaryRangeMin: text });
        pushAIChat("What is the maximum salary?");
        speak("What is the maximum salary?");
        return;
    }

    // STEP 3 — Salary Max
    if (!pending.SalaryRangeMax) {
        setPending({ ...pending, SalaryRangeMax: text });

        // 👇 EXPERIENCE LEVEL QUESTION WITH SUGGESTIONS
        if (experienceSuggestions?.length) {
            pushAIChat(
                `What experience level is this for?\nOptions: ${experienceSuggestions.join(", ")}`
            );
            speak("What experience level is this for?");
        } else {
            pushAIChat("What experience level is this for?");
            speak("What experience level is this for?");
        }
        return;
    }

    // STEP 4 — Experience Level → FINAL
    if (!pending.ExperienceLevel) {
        const finalData = {
            ...pending,
            ExperienceLevel: text,
        };

        pushAIChat(`Creating payscale...`);
        speak(`Creating payscale.`);

        window.dispatchEvent(
            new CustomEvent("ai-create-payscale", {
                detail: finalData,
            })
        );

        setPending(null);
    }
};
export const startDeletePayscaleFlow = (
    setPendingDelete: (data: PendingDeletePayscale | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void,
    roleNameFromIntent?: string
) => {
    if (roleNameFromIntent) {
        pushAIChat(`Deleting payscale for "${roleNameFromIntent}"...`);
        speak(`Deleting payscale for ${roleNameFromIntent}.`);

        window.dispatchEvent(
            new CustomEvent("ai-delete-payscale", {
                detail: { roleName: roleNameFromIntent },
            })
        );
        return;
    }

    setPendingDelete({ awaitingName: true });
    pushAIChat("Which role's payscale would you like to delete?");
    speak("Which role's payscale would you like to delete?");
};
export const processPendingDeletePayscale = (
    text: string,
    pending: PendingDeletePayscale,
    setPendingDelete: (data: PendingDeletePayscale | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void
) => {
    if (!pending.awaitingName) return;

    pushAIChat(`Deleting payscale for "${text}"...`);
    speak(`Deleting payscale for ${text}.`);

    window.dispatchEvent(
        new CustomEvent("ai-delete-payscale", {
            detail: { roleName: text },
        })
    );

    setPendingDelete(null);
};
